export const environment = {
  production: false,
  mockGigya: false,
  showLogs: true,
  domain: "des-partners",
  gigya: {
    apiKey: '4_qWXuxkJccAkMkbBxYilIEg',
  },
};
